// extracted by mini-css-extract-plugin
export default {"wrapper":"Download_wrapper__4bIO9","title":"Download_title__4O6NY","subTitle":"Download_subTitle__Kjk7E","checkbox":"Download_checkbox__UUOf7","clear":"Download_clear__mOWiU"};